"use client"

import { AuthUIProvider } from "@daveyplate/better-auth-ui"
import NextLink from "next/link"
import { useRouter } from "next/navigation"
import type { ReactNode } from "react"

import { authClient } from "~/utils/auth-client"

export function Providers({ children }: { children: ReactNode }) {
    const router = useRouter()

    return (
        <AuthUIProvider
            authClient={authClient}
            navigate={(...args) => router.push(...args)}
            replace={(...args) => router.replace(...args)}
            onSessionChange={() => {
                // Clear router cache (protected routes)
                router.refresh()
            }}
            Link={({ href, className, children }) => (
                <NextLink href={href} className={className}>
                    {children}
                </NextLink>
            )}
        >
            {children}
        </AuthUIProvider>
    )
}